/* Homepage "Design your own cage" promo.
   Draws a live cage with the shared engine (cage-builder.js), lets visitors flick
   between merchant-defined presets and colours, shows the starting estimate, and
   links through to the builder page with that build preselected (share-link
   query string). Hover previews on pointer devices; click/tap/keyboard selects. */
(function (global) {
  'use strict';

  function init() {
    var engine = global.CageBuilder;
    if (!engine) { return; }
    var cfg = engine.resolveConfig(typeof global.CAGE_PRICES === 'string' ? global.CAGE_PRICES : '');
    var roots = document.querySelectorAll('[data-cage-promo]');
    for (var i = 0; i < roots.length; i++) { setup(roots[i], engine, cfg); }
  }

  function num(el, name, def) {
    var v = parseInt(el.getAttribute('data-' + name), 10);
    return isNaN(v) ? def : v;
  }

  function readPreset(btn, cfg) {
    var w = num(btn, 'w', cfg.def_w);
    var h = num(btn, 'h', cfg.def_h);
    var d = num(btn, 'd', cfg.def_d);
    var partitions = num(btn, 'p', 0);
    var doorsPer = partitions === 0 ? num(btn, 'dpc', 1) : 1;
    var comps = [];
    for (var k = 0; k <= partitions; k++) { comps.push(w / (partitions + 1)); }
    return {
      label: btn.getAttribute('data-label') || '',
      w: w, h: h, d: d,
      compartments: comps,
      compartmentCount: partitions + 1,
      partitionCount: partitions,
      partitionsIsDefault: false,
      doorsPer: doorsPer,
      doorCount: doorsPer * (partitions + 1),
      customWidths: false,
      isWeatherproof: btn.getAttribute('data-wp') === '1',
      hasTopTray: btn.getAttribute('data-wp') !== '1' && btn.getAttribute('data-tray') === '1',
      escapeChoice: btn.getAttribute('data-esc') || 'none',
      hingeChoice: 'mirror',
      needsStrengthen: w > cfg.strengthen_over || d > cfg.strengthen_over
    };
  }

  function formatMoney(n) {
    try { return Math.round(n).toLocaleString('en-GB'); }
    catch (e) { return String(Math.round(n)); }
  }

  function setup(root, engine, cfg) {
    var cad = root.querySelector('[data-promo-cad]');
    var caption = root.querySelector('[data-promo-caption]');
    var price = root.querySelector('[data-promo-price]');
    var cta = root.querySelector('[data-promo-cta]');
    var presets = root.querySelectorAll('[data-promo-preset]');
    var colours = root.querySelectorAll('[data-promo-colour]');
    var currency = root.getAttribute('data-currency') || '£';
    var builderUrl = root.getAttribute('data-builder-url') || '';
    if (!cad || !presets.length) { return; }

    var selected = { preset: presets[0], colour: colours.length ? colours[0] : null };
    for (var p = 0; p < presets.length; p++) {
      if (presets[p].getAttribute('aria-pressed') === 'true') { selected.preset = presets[p]; }
    }
    for (var c = 0; c < colours.length; c++) {
      if (colours[c].getAttribute('aria-pressed') === 'true') { selected.colour = colours[c]; }
    }

    function markPressed(list, active) {
      for (var i = 0; i < list.length; i++) {
        list[i].setAttribute('aria-pressed', list[i] === active ? 'true' : 'false');
      }
    }

    function render(presetBtn, colourBtn) {
      var choice = readPreset(presetBtn, cfg);
      var hex = colourBtn ? (colourBtn.getAttribute('data-hex') || '') : '';
      var ral = colourBtn ? (colourBtn.getAttribute('data-ral') || '') : '';
      var name = colourBtn ? (colourBtn.getAttribute('data-name') || '') : '';
      choice.cageColorHex = hex;
      choice.cageColor = ral ? 'RAL ' + ral + (name ? ' ' + name : '') : '';
      choice.cageColorIsDefault = !ral;
      choice.doorColorHex = '';
      choice.doorColor = '';
      choice.doorColorIsDefault = true;

      cad.innerHTML = engine.buildWireframeSvg(choice);
      // Caption names the example and its size so the estimate reads as
      // "this example costs", not "all cages start from".
      if (caption) {
        caption.textContent = (choice.label ? choice.label + ', ' : '')
          + choice.w + ' x ' + choice.h + ' x ' + choice.d + ' mm';
      }

      // Estimate for this example in the standard finish.
      var buildable = !engine.sizeIssue(cfg, choice) && !engine.doorWidthIssue(cfg, choice);
      if (price) {
        if (buildable) {
          var standard = {};
          for (var k in choice) { standard[k] = choice[k]; }
          standard.cageColorCustom = false;
          standard.doorColorCustom = false;
          price.textContent = 'Est. ' + currency + formatMoney(engine.computePrice(cfg, standard));
          price.hidden = false;
        } else {
          price.hidden = true;
        }
      }
      if (cta && builderUrl) {
        var qs = engine.encodeChoices(cfg, choice);
        cta.setAttribute('href', builderUrl + (qs ? (builderUrl.indexOf('?') === -1 ? '?' : '&') + qs : ''));
      }
    }

    function commit() {
      markPressed(presets, selected.preset);
      markPressed(colours, selected.colour);
      render(selected.preset, selected.colour);
    }

    function bind(list, key) {
      for (var i = 0; i < list.length; i++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            selected[key] = btn;
            commit();
          });
          // Hover preview on pointer devices; reverts when the pointer leaves the group.
          btn.addEventListener('pointerenter', function (ev) {
            if (ev.pointerType && ev.pointerType !== 'mouse') { return; }
            render(key === 'preset' ? btn : selected.preset, key === 'colour' ? btn : selected.colour);
          });
        })(list[i]);
      }
    }
    bind(presets, 'preset');
    bind(colours, 'colour');
    var groups = root.querySelectorAll('[data-promo-group]');
    for (var g = 0; g < groups.length; g++) {
      groups[g].addEventListener('pointerleave', function () { render(selected.preset, selected.colour); });
    }

    commit();
  }

  if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  }
})(typeof window !== 'undefined' ? window : this);
